
export type CompareExchangeValueState = "None" | "Created" | "Deleted" | "Missing";